// No imports on purpose: apps/android/app.config.ts reads this file directly (Expo evaluates the config with plain
// Node, which cannot follow this package's extensionless imports), so it must stay a leaf.

/**
 * The Android app's identity and its Google Play catalog. The applicationId deliberately equals the Apple
 * bundle id (`ataman.bridewell`): one reverse-domain name for the product on every store. Once a build is
 * on Google Play the applicationId can never change.
 */
export const ANDROID_APP = {
  applicationId: "ataman.bridewell",
  /**
   * The URL scheme the app is addressed by. The API trusts it as a request origin (`trustedOrigins`), nothing more:
   * no token or session ever travels on it, because any other app on the phone can register the same scheme.
   */
  scheme: "bridewell",
  /** The live web app the Android app belongs to: the release build's API origin, the App Links host, the legal pages. */
  site: "https://bridewell.io",
} as const;

/** A deep link into the Android app, e.g. `appUrl("verified")` → `bridewell://verified`. */
export function appUrl(path = ""): string {
  return `${ANDROID_APP.scheme}://${path.replace(/^\/+/, "")}`;
}
